import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { OrthographicCamera } from 'three';
import { BoundingBox2 } from '../../share/boundingbox2';
import { SceneService } from '../scene.service';
import { RendererService } from '../renderer.service';

@Component({
  selector: 'ng3-orthographic-camera',
  template: ``,
  styles: [],
})
export class OrthographicCameraComponent implements OnInit {
  readonly camera = new OrthographicCamera(
    this.size.left,
    this.size.right,
    this.size.top,
    this.size.bottom
  );
  @Output() changed = new EventEmitter<void>();
  @Input()
  get size(): BoundingBox2 {
    return this.scene.size;
  }
  set size(b: BoundingBox2) {
    this.scene.resize(b);
  }
  @Input()
  z = 100;
  @Input() x;
  constructor(private scene: SceneService, private renderer: RendererService) {
    console.log(this.x);

    this.camera.position.z = this.z;
    this.scene.size$.subscribe(
      (b) => this.updateCameraSize(b),
      (e) => console.error(e)
    );
  }

  private updateCameraSize(b: BoundingBox2) {
    this.camera.bottom = b.bottom;
    this.camera.top = b.top;
    this.camera.left = b.left;
    this.camera.right = b.right;
    this.camera.zoom = 1;
    this.camera.updateProjectionMatrix();
    this.changed.emit();
    this.renderer.render();
  }
  ngOnInit() {}
}
